import React from 'react'
import getUrl from 'front-end-core/core/url'
import { LEGISLATION } from 'constants/controllers'
import Icon from 'components/shared/Icon'

const ListItem = ({ legislation, sectionId, name, aol, isLogged, setSignUpModalIsOpen }) => {
  const { archive: _archive, hidden, id, title } = legislation
  const archive = _archive ? 'archive' : false
  const handleOnClick = () => !isLogged && setSignUpModalIsOpen(true)

  return hidden
    ? null
    : (
      <li className='bb b--dark-orchid' key={id}>
        <a
          className='flex min-h3 justify-between items-center no-underline hover-bg-twilight-grey ma0 hover-no-underline pointer'
          href={isLogged ? getUrl(LEGISLATION, { aol, archive, path: id }) : null}
          data-event-action='Select'
          data-event-category='Legislation Folders'
          data-event-label={`${sectionId}: ${name} ${title}`}
          onClick={handleOnClick}
        >
          <span className='h-auto h3 black f5 fw6 mv4 mr0 ml6 lh-title'>{title}</span>
          <span className='mr7 black'><Icon className='w7' name='icon-arrow-right' /></span>
        </a>
      </li>
      )
}

export default ListItem
